/*
自定义页面弹窗  使用的话直接掉toast('里面穿提示的消息')
{{ 'custom-toast.css' | asset_url | stylesheet_tag }}
{{ 'custom-toast.js' | asset_url | script_tag }}

*/
const MAX_TOAST = 5;
        const DURATION = 3000;

        function toast(message,state='success') {//state状态码 success  warning  failed
            const list = [...document.querySelectorAll(".toast")];

            while (list.length >= MAX_TOAST) {
                removeToast(list[0]);
                list.shift();
            }

            const el = document.createElement("div");
            el.className = "toast";
            let svgsuccess = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10.0013" cy="10" r="8.33333" fill="#529426"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99503 13.3043C9.35681 14.0164 8.25154 14.0467 7.57536 13.3705L5.17423 10.9693C4.84879 10.6439 4.84879 10.1163 5.17422 9.79084C5.49966 9.4654 6.0273 9.4654 6.35274 9.79084L8.75387 12.192L13.3185 7.09872C13.6256 6.75599 14.1525 6.72715 14.4952 7.03431C14.8379 7.34147 14.8668 7.86832 14.5596 8.21106L9.99503 13.3043Z" fill="white"/>
                                </svg>
                                `
            let svgwarning = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10.0013" cy="9.99999" r="8.33333" fill="#F57232"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0013 12.0245C10.4615 12.0245 10.8346 11.6514 10.8346 11.1911L10.8346 5.48055C10.8346 5.02031 10.4615 4.64722 10.0013 4.64722C9.54106 4.64722 9.16797 5.02031 9.16797 5.48055L9.16797 11.1911C9.16797 11.6514 9.54106 12.0245 10.0013 12.0245Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0013 15.2339C10.4615 15.2339 10.8346 14.8608 10.8346 14.4006L10.8346 14.1667C10.8346 13.7064 10.4615 13.3333 10.0013 13.3333C9.54106 13.3333 9.16797 13.7064 9.16797 14.1667L9.16797 14.4006C9.16797 14.8608 9.54107 15.2339 10.0013 15.2339Z" fill="white"/>
                            </svg>
                            `
            let svgfailed = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10.0013" cy="10" r="8.33333" fill="#F53131"/>
                            <rect x="5.97266" y="7.15588" width="1.67188" height="9.71625" rx="0.835938" transform="rotate(-45 5.97266 7.15588)" fill="white"/>
                            <rect x="12.8438" y="5.97369" width="1.67188" height="9.71625" rx="0.835938" transform="rotate(45 12.8438 5.97369)" fill="white"/>
                            </svg>
                            `
            let svg;
            if (state) {
                el.classList.add('toast_' + state);
                svg = state=='success'?svgsuccess:(state=='warning'?svgwarning:svgfailed)
            }
            
            // el.textContent = message;
            el.innerHTML = `
            ${svg}
            <span class="toast-text">${message}</span>
            `
            document.body.appendChild(el);

            requestAnimationFrame(() => el.classList.add("toast-in"));

            // 初次定位（先摆好）
            requestAnimationFrame(repositionToasts);

            // 自动消失（可暂停）
            let remain = DURATION;
            let start = Date.now();
            let timer = setTimeout(() => removeToast(el), remain);

            el.addEventListener("mouseenter", () => {
                clearTimeout(timer);
                remain -= Date.now() - start;
            });

            el.addEventListener("mouseleave", () => {
                start = Date.now();
                timer = setTimeout(() => removeToast(el), remain);
            });
        }

        function removeToast(el) {
            if (!el || el.__closing) return;
            el.__closing = true;

            el.classList.remove("toast-in");
            el.classList.add("toast-out");

            el.addEventListener("animationend", () => {
                el.remove();
                repositionToasts(); // ⭐删除后重新排布并让它们丝滑上移
            });
        }

        function repositionToasts() {
            const toasts = [...document.querySelectorAll(".toast")];
            let offset = 20;

            toasts.forEach(t => {
                t.style.top = offset + "px";  // ⭐ 使用 transition 保证 toast 顺滑移动
                offset += t.offsetHeight + 10;
            });
        }